import React from 'react';
import { Button } from '@mui/material';
import { customerPrimaryButtonSx } from '../../constants/customerTheme';

const CustomerPrimaryButton = ({ sx, size, ...buttonProps }) => (
  <Button
    variant="contained"
    size={size}
    sx={{
      ...(size === 'small'
        ? {
            bgcolor: customerPrimaryButtonSx.bgcolor,
            fontWeight: 700,
            textTransform: 'none',
            '&:hover': customerPrimaryButtonSx['&:hover'],
          }
        : {
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: 180 },
            px: { sm: 3 },
            py: 1.1,
            ...customerPrimaryButtonSx,
          }),
      ...sx,
    }}
    {...buttonProps}
  />
);

export default CustomerPrimaryButton;
